import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { v4 as uuid } from 'uuid';
import { Field } from 'redux-form';
import cns from 'classnames';
import BasicSelect from '../../../../../shared/components/formComponents/groups/BasicSelect';
import BasicText from '../../../../../shared/components/formComponents/groups/BasicText';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../../shared/components/VerbButton';

class ShortEssayOption extends Component {
    static propTypes = {
        shortEssayDataSource: PropTypes.array,
        getFormValue: PropTypes.func,
        fields: PropTypes.array,
        disabled: PropTypes.bool
    };

    pushField = () => {
        this.props.fields.push({
            id: uuid(),
            label: '',
            itemId: ''
        });
    };

    removeField = (i) => {
        this.props.fields.remove(i);
    };

    moveUp = (i) => {
        if (i) {
            this.props.fields.swap(i, i - 1);
        }
    };

    moveDown = (i) => {
        if (i < this.props.fields.length - 1) {
            this.props.fields.swap(i, i + 1);
        }
    };

    render() {
        const { fields, shortEssayDataSource, getFormValue, disabled } = this.props;
        const fieldsArray = fields.map((memberReference, idx) => (
            <div key={getFormValue(`${memberReference}.id`)} className={'ase-input'}>
                <div className={'row optionButtons ms-auto'}>
                    <Button onClick={() => this.moveUp(idx)} className={'ase-swap-up col-offset-3 col-1'}>
                        <i className={'fa fa-angle-up'} />
                    </Button>
                    <Button onClick={() => this.moveDown(idx)} className={'ase-swap-down col-1'}>
                        <i className={'fa fa-angle-down'} />
                    </Button>
                    <Button onClick={() => this.removeField(idx)} className={'ase-delete col-1'}>
                        <i className={'fa fa-trash'} />
                    </Button>
                </div>
                <div className={'row'}>
                    <Field
                        name={`${memberReference}.label`}
                        label={'LABEL'}
                        className={'col-6'}
                        component={BasicText}
                        disabled={disabled}
                    />
                    <Field
                        name={`${memberReference}.itemId`}
                        className={'col-6'}
                        options={shortEssayDataSource}
                        label={'SHORT ESSAY REFERENCED'}
                        valueKey={'id'}
                        labelKey={'name'}
                        component={BasicSelect}
                        disabled={disabled}
                    />
                </div>
            </div>
        ));

        return (
            <div className={'aggregateShortEssay-optionFields col-12'}>
                {fieldsArray}
                <VerbButton
                    onClick={this.pushField}
                    type={'button'}
                    buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                    fontAwesomeIcon={'fa-plus'}
                    className={cns('ase-add-btn', { hidden: disabled })}
                />
            </div>
        );
    }
}

export default ShortEssayOption;
